import http from '@/utils/api-util'
import util, {encryptBosObjectKey, getFileExtName} from '@/utils/util'

export function getProjectOptions() {
    return http({
        url: '/app/getProjectOptions/',
        method: 'get',
    })
}

export function getEnumByClassName(name) {
    return http({
        url: '/sys/enum/info/' + name,
        method: 'get',
    })
}

export function getApplyInfo(id) {
    return http({
        url: '/app/prjInApply/info',
        method: 'post',
        data: {
            'id': id,
        }
    })
}

export function getInApplyNoticePicUrl() {
    return http({
        url: '/app/prjInApply/noticePicUrl',
        method: 'get',
    })
}

export function smsCodeSend(mobile) {
    return http({
        url: '/app/smsCode/send',
        method: 'post',
        params: {
            'mobile': mobile
        }
    })
}

// export function queryInApply(mobile, code, applyNo, businessType) {
//     return http({
//         url: '/app/prjInApply/query',
//         method: 'post',
//         data: {
//             'mobile': mobile,
//             'code': code,
//             'applyNo': applyNo,
//             'businessType': businessType
//         }
//     })
// }

export function inApply(applyName, prjBaseInfoId, inType, roomNumber, industrial, periodType, legalPerson, businessScope,
                        registeredCapital, registeredAddress, squareMeasure, expectYearValue, expectYearTax, contact, contactPhone,
                        attachmentList, businessType, enterpriseId, numberOfEmployees) {
    return http({
        url: '/app/prjInApply/apply',
        method: 'post',
        data: {
            'applyName': applyName,
            'prjBaseInfoId': prjBaseInfoId,
            'inType': inType,
            'roomNumber': roomNumber,
            'industrials': industrial,
            'periods': periodType,
            'legalPerson': legalPerson,
            'businessScope': businessScope,
            'registeredCapital': registeredCapital,
            'registeredAddress': registeredAddress,
            'squareMeasure': squareMeasure,
            'expectYearValue': expectYearValue,
            'expectYearTax': expectYearTax,
            'contact': contact,
            'contactPhone': contactPhone,
            'attachmentList': attachmentList,
            'businessType': businessType,
            'enterpriseId': enterpriseId,
            'numberOfEmployees': numberOfEmployees
        }
    })
}


export function getBosConfig(key) {
    let expiration = util.formatDate(new Date, 'yyyy-MM-ddThh:mm:ssZ')
    return http({
        url: '/app/bos/config',
        method: 'post',
        data: {
            'key': key,
            'expiration': expiration
        },
    })
}

export function getInApplyListByContactPhone(mobile, code, status) {
    return http({
        url: '/app/prjInApply/queryListByContactPhone',
        method: 'post',
        data: {
            'mobile': mobile,
            'code': code,
            'status': status
        },
    })
}

export function queryEnterPriseListByContactPhone(mobile, code) {
    return http({
        url: '/app/enterprise/queryListByContactPhone',
        method: 'post',
        data: {
            'mobile': mobile,
            'code': code,
        },
    })
}

export function companyLicenseApply(attachmentList, businessType, enterpriseId) {
    return http({
        url: '/app/prjInApply/apply',
        method: 'post',
        data: {
            'attachmentList': attachmentList,
            'businessType': businessType,
            'enterpriseId': enterpriseId,
        },
    })
}

export function proofForUseApply(attachmentList, businessType, enterpriseId, rentContractAddress, purpose,
                                 purposeDesc) {

    return http.post('/app/prjInApply/apply', {
        'attachmentList': attachmentList,
        'businessType': businessType,
        'enterpriseId': enterpriseId,
        'rentContractAddress': rentContractAddress,
        'purpose': purpose,
        'purposeDesc': purposeDesc,
    })
}

export function checkSmsCode(mobile, code, timestamp) {
    return http({
        url: '/app/sms/checkSmsCode',
        method: 'post',
        data: {
            'mobile': mobile,
            'code': code,
            'timestamp': timestamp
        },
    })
}

export function enterpriseCheckExist(name) {
    return http({
        url: '/app/enterprise/checkExist',
        method: 'post',
        params: {
            'name': name
        },
    })
}

export function getEnterpriseInfo(id) {
    return http({
        url: '/app/enterprise/info',
        method: 'get',
        params: {
            'id': id
        },
    })
}

export function enterpriseCheckInfo(mobile, code, name, timestamp) {
    return http({
        url: '/app/enterprise/checkInfo',
        method: 'post',
        data: {
            'mobile': mobile,
            'code': code,
            'name': name,
            'timestamp': timestamp
        },
    })
}

export function getBosSTSToken() {
    return http({
        url: '/app/bos/stsToken',
        method: 'post',
    })
}

export function uploadFile(uploadUrl, formData) {
    return http({
        url: uploadUrl,
        method: 'post',
        data: formData,
    })
}

export function getBOSObjectUrl(objectKey) {
    const timestamp = Date.now();
    const key = encryptBosObjectKey(objectKey, timestamp)
    return http({
        url: '/app/oss/getObjectUrl',
        method: 'get',
        params: {
            'objectKey': objectKey,
            'timestamp': timestamp,
            'key': key
        },
    })
}

export function uploadFileToBaiduCloud(file, successCallback, failCallback, isSignFile) {
    //首先请求服务器，取得上传到bos的参数
    var temp_url = URL.createObjectURL(new Blob());
    var uuid = temp_url.toString(); // blob:https://xxx.com/b250d159-e1b6-4a87-9002-885d90033be3
    URL.revokeObjectURL(temp_url);
    uuid = uuid.substr(uuid.lastIndexOf("/") + 1);
    let ossFileName = new Date().getTime() + uuid + '.' + getFileExtName(file.name)
    if (isSignFile) {
        ossFileName = 'img_rotate_90' + ossFileName
    }
    getBosConfig(ossFileName).then(res => {
        if (res.code === 0) {
            let config = res.data;
            let accessKey = config.accessKey;
            let url = config.url;
            let policy = config.policy;
            let signature = config.signature;

            let formData = new FormData()
            formData.append('accessKey', accessKey)
            formData.append('key', ossFileName)
            formData.append('signature', signature)
            formData.append('policy', policy)
            formData.append('file', file)
            uploadFile(url, formData).then(uploadRes => {
                getBOSObjectUrl(ossFileName).then(data => {
                    if (data && data.code === 0) {
                        let resultData = {
                            name: ossFileName,
                            url: data.data
                        }
                        successCallback(resultData)
                    } else {
                        failCallback()
                    }
                })
            });
        } else {
            failCallback(res)
        }
    })
}

















